<template>
  <div v-show="dialog">
    <v-timeline align-top dense>
      <v-timeline-item
        v-for="message in computedLogs"
        :key="message.id"
        :color="message.color"
        :icon="message.icon"
        small
      >
        <div
          :class="{ 'grey lighten-3': message.notifStatus }"
          class="py-2 px-4 rounded mt-n4"
        >
          <div class="font-weight-normal">
            <strong>{{ message.from }}</strong> @{{ message.time }}
          </div>
          <div v-html="formatMessage(message.message)"></div>
        </div>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
  String.prototype.allReplace = function(obj) {
    var retStr = this;
    for (var x in obj) {
      retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
    }
    return retStr;
  };

  let messageConfigDecrypt = {
    "&lt;": "<",
    "&gt;": ">",
  };

  import { mapActions } from "vuex";

  export default {
    name: "SubRouteTrackingLog",
    props: {
      dialog: Boolean,
      routeId: Number,
      routeType: String,
      logs: Array,
      notifLogCount: Number,
      userAccessing: Number,
      routeUserAssigned: Number,
    },
    data() {
      return {
        logData: this.logs,
        dialogm1: "",
      };
    },
    computed: {
      computedLogs() {
        return this.logData;
      },
    },
    methods: {
      ...mapActions(["fetchRouteLog", "viewLogStatus"]),
      closeDialog() {
        this.$emit("closeDialog", false);
      },
      formatMessage(message) {
        return message.allReplace(messageConfigDecrypt);
      },
    },
    mounted() {
      if (this.dialog) {
        if (this.userAccessing !== this.routeUserAssigned) return;

        setTimeout(() => {
          // set view to view all
          const body = {
            logs: this.logs.filter(log => log.notifStatus),
            route_id: this.routeId,
            type: this.routeType,
          };
          this.viewLogStatus(body).then(() => {
            this.logData = this.logData.map(data => ({
              ...data,
              notifStatus: false,
            }));

            this.$emit("setNewLogCount", 0);
          });
        }, 3000);
      }
    },
  };
</script>

<style></style>
